/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Hero_Start_FreeInputs */

const en_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free`)
};

const zh_hans1_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始`)
};

const pt_br2_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece grátis`)
};

const es_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza gratis`)
};

const fr_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer gratuitement`)
};

const de_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos starten`)
};

const ru_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать бесплатно`)
};

const it_endpoint_hero_start_free = /** @type {(inputs: Endpoint_Hero_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia gratis`)
};

/**
* | output |
* | --- |
* | "Start free" |
*
* @param {Endpoint_Hero_Start_FreeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_hero_start_free = /** @type {((inputs?: Endpoint_Hero_Start_FreeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Hero_Start_FreeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_hero_start_free(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_hero_start_free(inputs)
	if (locale === "es") return es_endpoint_hero_start_free(inputs)
	if (locale === "fr") return fr_endpoint_hero_start_free(inputs)
	if (locale === "de") return de_endpoint_hero_start_free(inputs)
	if (locale === "ru") return ru_endpoint_hero_start_free(inputs)
	if (locale === "it") return it_endpoint_hero_start_free(inputs)
	return en_endpoint_hero_start_free(inputs)
});